module.exports = __webpack_public_path__ + "static/media/fale-conosco.b78ef781.svg";